<template>
  <loader-wrapper
    :loading="getLoading('Bid')"
    style="position: relative"
    class="load-wrapper-map"
  >
    <div v-if="bids.length === 0 && !getLoading('Bid')" class="error-block">
      В настоящее время <br> погрузки отсутствуют
      <template v-if="isError && !loading">
        <p class="err-p"><b>Данные не загрузились</b></p>
      </template>
    </div>
    <yandex-map
      v-else
      :settings="settings"
      :coords="center"
      :bounds="mapCornersCoords"
      :controls="controls"
      :cluster-options="clusterOptions"
      ymap-class="ymap-driver"
      @map-was-initialized="mapLoaded"
      @actionend="onBalloonOpen"
    >
      <ymap-marker
        v-for="bid in bidsListMap"
        :key="bid.id"
        marker-type="placemark"
        :marker-id="bid.id"
        :coords="bid.coords"
        :icon="{ ...markerIcon, content: bid.num }"
        :balloon="renderBid(bid)"
        cluster-name="cluster"
      />
    </yandex-map>
  </loader-wrapper>
</template>

<script>
import {
  MAP_CENTER,
  clusterBidsOptions,
  markerSandIcon,
  ymapSettings,
} from './constants'
import { isBidViewed } from '@/helpers/visibilityOnScroll'
import { mapGetters } from 'vuex'
import BidMobile from '@/views/NewHomeMobile/components/BidMobile'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import Vue from 'vue'

export default {
  name: 'NewBidsMapOneRequest',
  components: { LoaderWrapper },
  props: {
    freights: {
      type: Object,
      default: () => {},
    },
    bids: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      controls: ['zoomControl'],
      center: MAP_CENTER,
      settings: ymapSettings,
      markerIcon: markerSandIcon,
      clusterOptions: clusterBidsOptions,
      map: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      getLoading: 'bids/getLoading',
      isError: 'bids/isError',
    }),
    bidsListMap() {
      let arr = []

      this.bids.map(bid => {
        arr.push({
          ...bid,
          coords: [bid['loading_point'].lat, bid['loading_point'].lng],
        })
      })

      return arr
    },
    // определяет координаты левого верхнего и правого нижнего углов карты
    // (чтобы все точки погрузок захватить)
    mapCornersCoords() {
      let leftCornerLatitude = 0 // max latitude
      let leftCornerLongitude = 360 // min longitude
      let rightCornerLatitude = 360 // min latitude
      let rightCornerLongitude = 0 // max longitude

      this.bidsListMap.map(bid => {
        if (Number(bid.coords[0]) > leftCornerLatitude) {
          leftCornerLatitude = Number(bid.coords[0])
        }
        if (Number(bid.coords[0]) < rightCornerLatitude) {
          rightCornerLatitude = Number(bid.coords[0])
        }
        if (Number(bid.coords[1]) < leftCornerLongitude) {
          leftCornerLongitude = Number(bid.coords[1])
        }
        if (Number(bid.coords[1]) > rightCornerLongitude) {
          rightCornerLongitude = Number(bid.coords[1])
        }
      })

      return [[leftCornerLatitude + 1.1, leftCornerLongitude - 0.5], [rightCornerLatitude - 0.2, rightCornerLongitude + 0.5]]
    },
  },
  mounted() {
    document.addEventListener('click', this.emitNext)
  },
  methods: {
    emitNext(e) {
      let bidId = Number(e.target.getAttribute('id'))
      let bid = this.bids.filter(item => item.id === bidId)

      if (bid.length > 0) {
        this.$emit('next', bid[0])
      }
    },
    renderBid(bid) {
      const propsData = { bid, freight: this.freights[bid.freight_id] }
      const comp = new Vue({
        ...BidMobile,
        parent: this,
        propsData,
      }).$mount()

      return { body: comp.$el.outerHTML }
    },
    onBalloonOpen(e) {
      if (e?.originalEvent?.map?.balloon?.isOpen()) {
        isBidViewed(this, '.customBalloon')
      }
    },
    mapLoaded(e) {
      e.options.set('suppressMapOpenBlock', true)
      this.map = e
      this.setCenter()
    },
    setCenter() {
      if (this.bids.length && this.bids[0].coords) {
        this.center = this.bids[0].coords
      }
    },
    stopLoading() {
      this.loading = false
    },
  },
}
</script>

<style lang="sass">
$menu-height: 7rem
.customBalloon
  padding: 0

.error-block
  position: absolute
  top: 11rem
  left: 0
  right: 0
  text-align: center
  font-size: 1.4rem
  color: #909399
  z-index: 90
.load-wrapper-map
  margin-top: 6.2rem
.ymap-driver
  height: calc(100vh - 6.2rem - #{$menu-height})
  .btn-block
    display: flex
    justify-content: center

  [class*=balloon-pane]
    @media screen and (max-width: 600px)
      z-index: 999999!important
  [class*=balloon-overlay]
    @media screen and (max-width: 600px)
      left: 56px!important
      top: 501px!important
  [class*=balloon_to_top]
    top: -330px!important
    border: none
    box-shadow: none
    @media screen and (max-width: 600px)
      top: -398px!important
    [class*=balloon__layout]
      width: 600px
      border-radius: 12px 12px 0 0
      background: transparent
      @media screen and (max-width: 600px)
        width: 100vw
      [class*=balloon__content]
        margin: 0
        font-family: 'Rubik', sans-serif
        width: 600px !important
        padding: 4px 7px 8px 8px
        background: transparent
        @media screen and (max-width: 600px)
          width: 100vw !important
          padding: 0
      [class*=balloon__content] > *
        width: 100% !important
        height: calc(100vh - 11.9rem - 127px) !important
        overflow: auto !important
      [class*=balloon__close]
        position: absolute
        top: .5rem
        right: .7rem
        margin-bottom: 0
        [class*=balloon__close-button]
          width: 3rem
          height: 3rem

  [class*=balloon__tail]
    display: none

  .calc-cluster-balloon
    font-family: 'Rubik', sans-serif
  .ballon_body
    border: none
    background: none
    width: 100%!important
  .el-card
    font-family: 'Rubik', sans-serif !important
    line-height: 125%!important
    box-shadow: none
    width: 400px!important
    @media screen and (max-width: 375px)
      width: 88%!important
    @media screen and (min-width: 414px)
      width: 86%!important
    @media screen and (min-width: 600px)
      width: 360px!important

  [class*="default-cluster"] > *
    color: #6D7996
    position: absolute
    top: 0
    left: 38px
    font-family: Rubik, sans-serif
    font-weight: 900
    font-size: 15px

</style>
